/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: navigation dropdown
 | -------------------------------------------------------------
 |
 |  Functionality for navigation dropdowns.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const navigationDropdowns = [...document.querySelectorAll('.mgbdes__navigation-dropdown')]

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

const closeNavigationDropdown = navigationDropdown => {
  const navigationDropdownButton = navigationDropdown.querySelector('button')
  navigationDropdown.classList.remove('open')

  // return focus to parent element on close
  // navigationDropdownButton.focus()

  // set aria expanded false on closing current button
  navigationDropdownButton.setAttribute('aria-expanded', false)
}

const openNavigationDropdown = navigationDropdown => {
  const navigationDropdownButton = navigationDropdown.querySelector('button')

  navigationDropdown.classList.add('open')

  // set aria expanded true on opening current button
  navigationDropdownButton.setAttribute('aria-expanded', true)
}

const isNavigationDropdownOpen = navigationDropdown => {
  return navigationDropdown.classList.contains('open')
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

// add click event
// check if a toggle card is present on page, if yes, loop through each single toggle card
navigationDropdowns && navigationDropdowns.forEach(navigationDropdown => {
  const toggleButton = navigationDropdown.querySelector('.parent__link')
  toggleButton.addEventListener('click', event => {
    isNavigationDropdownOpen(navigationDropdown)
      ? closeNavigationDropdown(navigationDropdown)
      : openNavigationDropdown(navigationDropdown)
  })
})

navigationDropdowns && navigationDropdowns.forEach(navigationDropdown => {
  const dropdownParent = navigationDropdown.querySelector('.dropdown__parent')
  const dropdownButton = dropdownParent.querySelector('.parent__link')

  dropdownParent.addEventListener('keydown', event => {
    const dropdownMenu = navigationDropdown.querySelector('.dropdown__menu')
    const dropdownMenuItem = dropdownMenu.querySelector('.menu__item')
    const key = event.key
    let targetItem

    // trigger dropdown menu with down arrow
    if (event.target.closest('.parent__link')) {
      if (key === 'ArrowDown') {
        event.preventDefault()
        openNavigationDropdown(navigationDropdown)

        targetItem = dropdownMenuItem

        // set focus on target item
        if (targetItem) {
          targetItem.querySelector('a, button').focus()
        }
      }

      if (key === 'Escape') {
        closeNavigationDropdown(navigationDropdown)
      }
    }

    // navigate inside dropdown menu items
    if (event.target.closest('.item__link')) {
      const currentDropdownItem = event.target.closest('.item__link')
      const dropdownMenuItems = [...dropdownMenu.querySelectorAll('.item__link')]
      const index = dropdownMenuItems.findIndex(item => item === currentDropdownItem)

      if (key === 'ArrowDown') {
        event.preventDefault()

        // if it's the last item, go the first, else go to next
        if (dropdownMenuItems.indexOf(currentDropdownItem) === dropdownMenuItems.length - 1) {
          targetItem = dropdownMenuItems[0]
        } else {
          targetItem = dropdownMenuItems[index + 1]
        }
      }

      if (key === 'ArrowUp') {
        event.preventDefault()

        // if it's the first item, go the last, else go to next
        if (dropdownMenuItems.indexOf(currentDropdownItem) === 0) {
          targetItem = dropdownMenuItems[dropdownMenuItems.length - 1]
        } else {
          targetItem = dropdownMenuItems[index - 1]
        }
      }

      if (key === 'Escape') {
        closeNavigationDropdown(navigationDropdown)
        dropdownButton.focus()
      }

      // set focus on target item
      if (targetItem) {
        targetItem.focus()
      }
    }
  })
})
